import React from 'react';
import { Table } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import SortedColumnIcon from './SortedColumnIcon';

const SortedColumn = ({
  name,
  sorted,
  asc,
  onClick,
  canBeCleared,
}) => (
  <Table.HeaderCell singleLine>
    <SortedColumnIcon sorted={sorted} canBeCleared={canBeCleared} asc={asc} onClick={onClick} />
    {name && (<FormattedMessage className="table-column-header" id={`table.header.${name}`} />)}
  </Table.HeaderCell>
);

export default SortedColumn;
